import PropTypes from 'prop-types';
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import cx from 'classnames';
import styles from './Label.module.css';
import measureSize from '../../hocs/measureSize';
import Measurement from '../../containers/handoff/Measurement';
var MARGIN = 5;
function Label(_a) {
    var _b;
    var sizeRef = _a.sizeRef, size = _a.size, renderedImageDimensions = _a.renderedImageDimensions, guide = _a.guide, value = _a.value, isGuideVertical = _a.isGuideVertical, unit = _a.unit;
    var position;
    if (isLabelOffTopOfScreen(size, guide, isGuideVertical)) {
        position = { top: MARGIN };
    }
    else if (isLabelOffRightOfScreen(size, guide, isGuideVertical, renderedImageDimensions.width)) {
        position = { right: MARGIN };
    }
    else if (isLabelOffBottomOfScreen(size, guide, isGuideVertical, renderedImageDimensions.height)) {
        position = { bottom: MARGIN };
    }
    else if (isLabelOffLeftOfScreen(size, guide, isGuideVertical)) {
        position = { left: MARGIN };
    }
    var className = cx(styles.label, (_b = {},
        _b[styles.centre] = !position,
        _b[styles.centreHorizontal] = position && !isGuideVertical,
        _b[styles.centreVertical] = position && isGuideVertical,
        _b));
    return (React.createElement("span", { className: className, ref: sizeRef, style: position }, value && React.createElement(Measurement, { unit: unit, value: value })));
}
Label.propTypes = {
    sizeRef: PropTypes.func,
    size: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
    }),
    renderedImageDimensions: PropTypes.shape({
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
    }),
    value: PropTypes.number,
    screenWidth: PropTypes.number,
    screenHeight: PropTypes.number,
    guide: PropTypes.object.isRequired,
    isGuideVertical: PropTypes.bool,
    unit: PropTypes.string,
};
function isLabelOffTopOfScreen(_a, guide, isGuideVertical) {
    var height = _a.height;
    return ((!isGuideVertical && guide.top < (height + MARGIN) / 2) ||
        (isGuideVertical && guide.top === 0 && guide.height < height + MARGIN));
}
function isLabelOffRightOfScreen(_a, guide, isGuideVertical, screenWidth) {
    var width = _a.width;
    return ((!isGuideVertical &&
        screenWidth === guide.left + guide.width &&
        guide.width < width + MARGIN) ||
        (isGuideVertical && screenWidth - guide.left < (width + MARGIN) / 2));
}
function isLabelOffBottomOfScreen(_a, guide, isGuideVertical, screenHeight) {
    var height = _a.height;
    return ((!isGuideVertical && screenHeight - guide.top < (height + MARGIN) / 2) ||
        (isGuideVertical && screenHeight - guide.top < height + MARGIN));
}
function isLabelOffLeftOfScreen(_a, guide, isGuideVertical) {
    var width = _a.width;
    return ((!isGuideVertical && guide.left === 0 && guide.width < width + MARGIN) ||
        (isGuideVertical && guide.left < (width + MARGIN) / 2));
}
export default measureSize(Label);
